import { render, staticRenderFns } from "./TourListPage.vue?vue&type=template&id=2d54d0af&scoped=true&"
import script from "./TourListPage.vue?vue&type=script&lang=js&"
export * from "./TourListPage.vue?vue&type=script&lang=js&"
import style0 from "./TourListPage.vue?vue&type=style&index=0&id=2d54d0af&prod&scoped=true&lang=scss&"
import style1 from "./TourListPage.vue?vue&type=style&index=1&id=2d54d0af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54d0af",
  null
  
)

export default component.exports